import React, { Component } from 'react';
import PropTypes from 'prop-types';
import common from 'ui-react-common';

const config = common.config;

const InputField = common.ui.components.forms.InputField;

export const validation = {
    validateOn: ['blur'],
    validationRegex: config.global.validation.patterns.firstName,
    required: true,
    message: {
        default: 'Please enter your first name',
    },
};

class FirstName extends Component {
    render() {
        const { value, disabled } = this.props;
        return (
            <InputField
                id="firstName"
                name="firstName"
                type="text"
                placeholder="First Name"
                validation={validation}
                value={value}
                disabled={disabled}
            />
        );
    }
}

FirstName.defaultProps = {
    value: undefined,
};

FirstName.propTypes = {
    value: PropTypes.string,
};

export default FirstName;
